import { useCallback, useState } from "react";

import useAxios from "@src/utility/hooks/use-axios";
import { useParams } from "react-router-dom";

export default function useCompanyCard () {
    const { platformId } = useParams();
    const [historyData, setHistoryData] = useState({});
    const { axiosInstance: historyInstance, loading } = useAxios({
        base: "panel"
    });

    const getStageHistory = useCallback(async (id) => {
        try {
            const { data } = await historyInstance.get(`/client/${platformId}/history/${id}`);
            if (data) {
                setHistoryData(data);
            }
        } catch (error) {
            console.error("Error fetching history:", error);
        }
    }, [historyInstance]);

    return {
        historyData,
        getStageHistory,
        loading
    };
}
